// INSTALLED 
import { Divider } from '@mui/material';
import { mtDividerUpTable } from '../../commons';
import { TableLogAcciones } from '../../components/tables/TableLogAcciones';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';



// CUSTOM 



/**
 * LogAcciones component renders the log actions page.
 * It includes breadcrumbs and title, a divider, and a table of log actions.
 *
 * @component
 * @example
 * return (
 *   <LogAcciones />
 * )
 */
export const LogAcciones = () => {
  return (
    <div>
        
        <BreadCrumbsAndTitle
                      title="Log Acciones" 
                      mainModule="configuracion" 
                      parent="Log Acciones"
                      action="" />

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.logacciones} /> 
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>
        
        <TableLogAcciones />
    </div>
  )
}


